<template>
  <div class="page">
    <div id="pdfContent1" class="pdf-box">
      <div>
        <PdfTop
          :title="'群体对比'"
          :search-params="searchParams"
          :classroom-name="classroomName"
          :sex-name="sexName"
          :age-name="ageName"
          :compare-name="compareName"
        />
        <div class="con-box">
          <MainTitle title="体格发育对比" tag="BMI分布" />
          <div class="clearfix mt20">
            <BasePanel
              v-if="frirstChartData.title"
              padding="20px"
              :style="{width: dataLength > 3 ? '100%' : ''}"
              class="chart-item"
              :title="frirstChartData.title"
              title-color="#fff"
              head-bg="#FF7146"
              head-border-color="#FF7146"
            >
              <BarDashedLine
                :data-list="frirstChartData.details"
                :color-list="colorList"
              />
            </BasePanel>
            <BasePanel
              v-for="(item, index) in barDataArray"
              :key="index"
              :title="item.title"
              :style="{width: dataLength > 3 ? '100%' : ''}"
              :title-color="colorList[index]"
              padding="20px"
              class="chart-item"
            >
              <BarDashed
                type="占比"
                :data-list="item.details"
                :color="colorList[index]"
              />
            </BasePanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupCompareBMIDistribute,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from './BasePanel.vue'
import BarDashedLine from '../../_components/charts/BarDashedLine.vue'
import BarDashed from '../../_components/charts/BarDashed.vue'
import PdfTop from './PdfTop.vue'
import MainTitle from './MainTitle.vue'

export default {
  components: {
    BasePanel,
    BarDashedLine,
    BarDashed,
    PdfTop,
    MainTitle
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      pieData: {},
      barDataArray: [],
      itemList: [
        {
          name: '较瘦 占比＜5%',
          color: '#3A91FF'
        },
        {
          name: '正常 5%≤占比≤85%',
          color: '#6DD400'
        },
        {
          name: '超重 85%＜占比≤95%',
          color: '#FFA100'
        },
        {
          name: '肥胖 占比＞95%',
          color: '#A35DFF'
        }
      ],
      colorList: [],
      classroomName: '',
      sexName: '',
      ageName: '',
      compareName: '',
      frirstChartData: {},
      dataLength: 0
    }
  },
  created() {
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    const compareNames = []

    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    this.$enums.classroomTypes.map((v) => {
      if (params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
      }
    })
    this.compareName = compareNames.join('、')
    groupCompareBMIDistribute(params).then((res) => {
      this.dataLength = res.data.bmidistribute.details.length
      this.frirstChartData = res.data.bmidistribute
      this.barDataArray = res.data.barChart || []
    })
    this.itemList.map((v) => {
      this.colorList.push(v.color)
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 20px 30px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 320px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
